import { Component, OnInit, HostListener, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, NavigationExtras, RouterOutlet, Routes, NavigationEnd } from '@angular/router';
import { DwRoutingMessageService, AG_GRID_FW_COMPONENT, DwNewRouteKeyService, DwLanguageService, DwUserStorage, GetloadingService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent, Observable } from 'rxjs';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
import { FxLoingingService } from 'app/implementation/auth/fx-login.service';
// import { DwUserService } from '@webdpt/framework';
import { DwModalService } from 'ng-quicksilver';
import * as crypto from 'crypto-js';
import { DwAuthService } from '../../../../../../projects/webdpt/framework/auth/auth.service';
import { FxModalService } from 'app/implementation/shared/components/fx-modal/fx-modal.service';
import { ChangePasswordComponent } from 'app/implementation/shared/layout/dw-tab-routing/change-password/change-password.component';
import { async } from '@angular/core/testing';
import { Fxed020PayNewComponent } from 'app/implementation/programs/e/fxed020/fxed020-pages/fxed020-personalCenter/fxed020-personalCenter/fxed020-pay-new/fxed020-pay.component';
import { DwSystemConfigService } from '../../../../../../projects/webdpt/framework/config/config.service';
import * as moment from 'moment';
import { Fxed020QRcodeComponent } from '../fxed020/fxed020-pages/fxed020-personalCenter/fxed020-personalCenter/fxed020-qrcode/fxed020-qrcode.component';

@Component({
  selector: 'app-fxed020-s01',
  templateUrl: './fxed020-s01.component.html',
  styleUrls: ['./fxed020-s01.component.less']
})
export class Fxed020S01Component implements OnInit {
  public wxkefu: any = []; //微信客服
  public programId = 'fxed020'; // 作业编号
  // public goodsList = ["网站首页", "行业应用", "案例中心", "我的产品", "我的专案", "下载中心"];
  public isMoving: boolean = false;
  public isShow; //记录当前菜单状态
  public isFirst: boolean = false;
  @ViewChild('loading') Load: ElementRef;

  //框架结构
  public layoutFrame: any = [];
  public listDatas: any[]; //所有商品品类
  public phoneCode: any[]; //手机扫码
  public ent: any;
  public navigationSubscription;
  public userInfo = {
    userId: '',
    userName: '',
    orgId: '',
    orgName: '',
    custId: '',
    custName: '',
    mainLang: 'zh_CN',
    mainLangName: '简体中文'
  }; // 用户信息
  public serchstrInfo = '';
  public c_P087: string = '';
  public c_P088: string = '';
  public c_P089: string = 'N';
  public c_P090: string = 'N';
  public c_P091: string = 'N';
  public c_P092: string = 'N';
  public c_P093: string = 'N';
  public c_P094: string = 'N';
  public querySolutionCenterShow = false;// 案例中心
  public downloadCenterShow = false;// 下载中心
  public studyCenterShow = false;// 学习中心
  public helpCenterShow = false;// 帮助中心
  public newsCenterShow = false;// 新闻中心
  public personalCenterShow = false;// 我的中心
  public orderMeetingShow = false;// 订货会
  public orgList: any;  // 当前用户的组织信息
  public custList: any; //当前用户渠道商列表
  public langList = []; //语言别列表
  public translate = {
    login: 'login'
  };
  public iphoneImg = ''; //二维码图片
  public iphoneIntro = '';//扫码标题
  public iphoneCode = ''; //扫码关注
  public isShowIphone = false;
  public browserLang: any; // 浏览器语言
  public searchModel = ''; // 搜索
  public isLoad = '1';
  public logoImg: any = ''; // 商城log
  public logoTxt: any = ''; // 商城log名称
  public activeTab: any = ''; // 当前选中页签名称
  public hoverTab: any = ''; // 记录鼠标移入tab
  public isOrderMeenting = false;
  public isbtnPayShow = false;
  public isInputEnt = false;// 记录是否ent是从url录入的，默认false非手动录入的
  constructor(
    protected http: FxDapHttpClient,
    public router: DwNewRouteKeyService,
    public router2: Router,
    protected route: ActivatedRoute,
    public dwMessage: DwRoutingMessageService,
    private fb: FormBuilder,
    private fxUserService: FxUserInfoService,
    public fxLoingingService: FxLoingingService,
    // private userService: DwUserService, // 用户信息
    private fxModalService: FxModalService,
    public dwModalService: DwModalService,
    private authService: DwAuthService, // 登陆
    private translateService: TranslateService,
    private languageService: DwLanguageService,
    private elementRef: ElementRef, private renderer: Renderer2,
    public load: GetloadingService,
    private systemConfig: DwSystemConfigService,
  ) {
    this.router2.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    // 获取浏览器语言
    const language = navigator.language.toLowerCase();
    if (language.indexOf('zh-cn') > -1) {
      this.browserLang = 'zh_CN';
    } else if (language.indexOf('en') > -1) {
      this.browserLang = 'en_US';
    } else if (language.indexOf('zh-tw') > -1) {
      this.browserLang = 'zh_TW';
    } else {
      this.browserLang = 'zh_CN';
    }
    this.fxUserService.getSysEnumById$('6').subscribe(response => {
      this.langList = response;
    });
    // this.langList = [
    //   {value: 'zh_CN', label: '简体中文'},
    //   {value: 'en_US', label: 'English'}
    // ]
    console.log(route);
    route.queryParamMap.subscribe( // 路由变化执行
      params => {
        this.ent = params.get('ent') || "";
        if (this.ent) {
          this.isInputEnt = true;
          this.setEnt();
        } else {
          this.isInputEnt = false;
          if (!this.fxUserService.myEnt) {
            const ent = sessionStorage.getItem('DwFxed020EntInfo');
            if (ent) {
              this.ent = ent
              this.setEnt();
            } else {
              this.getAas();
            }
          } else {
            this.ent = Number(this.fxUserService.myEnt);
          }
        }
        if (!this.fxUserService.userInfo['c_user'] ||  !this.fxUserService.userInfo['c_user_n1'] || !this.fxUserService.userInfo['c_cust']) {
          var param = {
            c_ent: this.ent,
            language: this.fxUserService.userInfo['c_lang'] || this.browserLang
          }
          this.onChangeUser(param, 'in');
        } else  {
          this.getUserInfo();
        }
      }
    );
    this.translate.login = this.translateService.instant('fxed020-login');
    // 获取url
    const windowUrl = window.location.href;
    if (windowUrl) {
      if (windowUrl.indexOf('home/info/0') !== -1) {
        this.activeTab = 'info/0';
        localStorage.setItem('name','')
      } else if (windowUrl.indexOf('querySolutionCenter') !== -1) {
        this.activeTab = 'querySolutionCenter';
      } else if (windowUrl.indexOf('downloadcenter') !== -1) {
        this.activeTab = 'downloadcenter';
      } else if (windowUrl.indexOf('studycenter') !== -1) {
        this.activeTab = 'studycenter';
      } else if (windowUrl.indexOf('helpcenter') !== -1) {
        this.activeTab = 'helpcenter';
      } else if (windowUrl.indexOf('newList') !== -1) {
        this.activeTab = 'newList';
      } else if (windowUrl.indexOf('personalCenter') !== -1) {
        this.activeTab = 'personalCenter';
      } else if (windowUrl.indexOf('orderMeeting') !== -1) {
        this.activeTab = 'orderMeeting';
        this.isOrderMeenting = true;
      } else if (windowUrl.indexOf('orderinfo') !== -1) {
        this.activeTab = 'orderMeeting';
        this.isOrderMeenting = true;
      } else if (windowUrl.indexOf('car2') !== -1) {
        this.activeTab = 'orderMeeting';
        this.isOrderMeenting = true;
      } else {
        if (windowUrl.indexOf('home/') === -1) {
          this.activeTab = 'home';
        }
      }
    }
  }

  ngOnInit() {
    const searchStr = sessionStorage.getItem('fxed020GoodsInfoSearch')
    if (searchStr) {
      this.searchModel = searchStr;
    }
    // if (this.fxUserService.userInfo.hasOwnProperty('token') && this.fxUserService.userInfo['token'] != '') {
    //   this.getSearchCondition();
    // } else {
      // this.serchstrInfo = '请输入商品';
    // }
    this.getFooter('admin'); //获取微信客服
    this.getSearchCondition();


    // sessionStorage.setItem('isSwitchOrg', 'N');

    // 获取用户信息
    // this.getUserInfo();

    //获取框架数据结构
    this.setEnt();
    this.getProgramParam();
    this.getButton();//获取按钮权限

  }

  public getButton() {
    const param={
      "param":{
        "program_no": "fxed020"
      }
    }
    this.http.post<any>('A/IACommonService/showButtonDisplay',param).subscribe( //获取按钮权限
      response=>{
        if (response.success && response.data) {
          for(var i=0;i<response.data.length;i++){
            if(response.data[i].id == 'btnPay'){
              this.isbtnPayShow = true;
              break;
            }
          }
        }
      }
    )
  }

  public setEnt() {
    if (this.ent == "") {
      return;
    }
    this.fxUserService.readEnt(this.ent).subscribe(
      data => {
        if (!data['success']) {
          console.log(111);
          return;
        }
      }, error => {
        console.log(error);
      }
    );
  }

  getFooter(key: any) {
    const param = {
      "param": {
        "ent": this.ent,
        "c_user": this.fxUserService.userInfo['c_user'],
        "language": this.fxUserService.userInfo['c_lang'],
        "dfb003": this.fxUserService.userInfo['c_cus']
      }
    };
    this.http.post<any>('D/IFxdi405Service/getPageFooterInfo', param).subscribe(
      response => {
        if ( response.data) {
          this.wxkefu = response.data.dfa9_list;
          sessionStorage.setItem('wechat', JSON.stringify(response.data.dfa9_list));
          sessionStorage.setItem('mail', JSON.stringify(response.data.dfa5_list))
        }
        setTimeout(() => {
          this.load.getMask('', false)
        }, 800);
      }, error => {
        throw new error('0000')
      }
    )
  }

  // 设置鼠标移入tab样式
  public setEnterClass(tab): void {
    this.hoverTab = tab;
  }
  // 初始化数据
  public initData(xList) {
    console.log('initData----', this.fxUserService.userInfo)
    this.userInfo = {
      userId: this.fxUserService.userInfo['c_user'] ? this.fxUserService.userInfo['c_user'] : '',
      userName: this.fxUserService.userInfo['c_user_n1'] ? this.fxUserService.userInfo['c_user_n1'] : '',
      orgId: this.fxUserService.userInfo['c_cus'] ? this.fxUserService.userInfo['c_cus'] : '',
      orgName: this.fxUserService.userInfo['c_cus_n1'] ? this.fxUserService.userInfo['c_cus_n1'] : '',
      custId: this.fxUserService.userInfo['c_cust'] || '',
      custName: this.fxUserService.userInfo['c_cust_n1'] || '',
      mainLang: this.fxUserService.userInfo['c_lang'] || this.translateService.getDefaultLang(),
      mainLangName: this.getLangName(this.fxUserService.userInfo['c_lang'] || this.translateService.getDefaultLang())
    };
    // this.orgList = orgList;
    this.custList = xList;
    this.getFrameData();
  }

  // 获取用户菜单
  async getMenuTreeByUser(reload): Promise<any> {
    const menuTree = this.fxUserService.userInfo['menuTree'];
    if (!menuTree || menuTree.length == 0 || reload) {
      this.fxUserService.getMenuTreeByUser().subscribe(res => {
        if (res.length) {
          this.fxUserService.userInfo['menuTree'] = res;
          this.setMenuAuth(res);
        }
      })
    } else {
      this.setMenuAuth(menuTree);
    }
  }

  // 根据菜单权限设置动态隐藏/显示tab
  setMenuAuth(menuTree) {
    menuTree.forEach(s => {
      switch (s.id) {
        case 'querySolutionCenter': // 案例中心
          this.querySolutionCenterShow = true;
          break;
        case 'downloadCenter':// 下载中心
          this.downloadCenterShow = true;
          break;
        case 'studyCenter':// 学习中心
          this.studyCenterShow = true;
          break;
        case 'helpCenter':// 帮助中心
          this.helpCenterShow = true;
          break;
        case 'newsCenter':// 新闻中心
          this.newsCenterShow = true;
          break;
        case 'personalCenter':// 我的中心
          this.personalCenterShow = true;
          break;
        case 'orderMeeting':// 订货会
          this.orderMeetingShow = true;
          break;
      }
    })
    console.log(menuTree);
  }

  getLangName(xlang) {
    var filterData = this.langList.filter(obj => obj.value == xlang);
    return filterData.length> 0 ? filterData[0].label : '简体中文';
  }

  async getProgramParam(): Promise<any> { // 获取作业参数
    this.http.post('A/IACommonService/getProgramParamAllowAnonymous', {
      param: {"entNo": this.ent, "program_no":"fxed020"}
    }).subscribe((response: any) => {
      if (response.data && response.data.length) {
        this.ent = response.data[0].aas002;
        this.c_P087 = response.data.filter(obj => obj.aai002 === 'c_P087')[0].aai003//是否显示首页
        this.c_P088 = response.data.filter(obj => obj.aai002 === 'c_P088')[0].aai003//是否显示产品中心
        // this.c_P089 = response.data.filter(obj => obj.aai002 === 'c_P089')[0].aai003//是否显示案例中心
        // this.c_P090 = response.data.filter(obj => obj.aai002 === 'c_P090')[0].aai003//是否显示下载中心
        // this.c_P091 = response.data.filter(obj => obj.aai002 === 'c_P091')[0].aai003//是否显示学习中心
        // this.c_P092 = response.data.filter(obj => obj.aai002 === 'c_P092')[0].aai003//是否显示新闻中心
        // this.c_P093 = response.data.filter(obj => obj.aai002 === 'c_P093')[0].aai003//是否显示产品中心
        // this.c_P094 = response.data.filter(obj => obj.aai002 === 'c_P094')[0].aai003//是否显示订货会
      }
    });
  }
  public getAas() {
    //获取系统参数
    var systemKeys = ['c_S001'];
    this.http.post('A/IACommonService/pub_upd_aas', {
      param: systemKeys
    }).subscribe((response: any) => {
      if (response.data && response.data.length) {
        this.ent = response.data[0].aas002;
        this.setEnt();
      } else {
        this.dwMessage.error(response.message);
        return;
      }
      setTimeout(() => {
        this.load.getMask('', false)
      }, 800);
    });
  }
  //获取验证码token
  // getToken() {
  //   let param = {};
  //   this.http.post<any>('A/ILoginService/getCaptchaData',param).subscribe(
  //     response => {
  //       //this.listDatas = response.data_raw;
  //       console.log(response,'listDatas')

  //     }, error => {
  //       this.layoutFrame = [];
  //     }
  //   )

  // }
  // 查询
  searchData(): void {
    sessionStorage.setItem('fxed020GoodsInfoSearch', this.searchModel);
    sessionStorage.setItem('load', this.isLoad);
    this.router.navigate(['home/info/0']);
  }
  //获取框架结构入口
  getFrameData(): void {
    if (this.ent == "" && !(this.fxUserService.userInfo['isLoggedin'] === true && this.fxUserService.userInfo['c_ent'])) {
      return;
    }
    this.listDatas = [];
    //入参
    let param = {
      "param": {
        "c_user": this.fxUserService.userInfo['c_user'],
        "language": this.fxUserService.userInfo['c_lang'],
        "ent": this.ent,
        "dfb003": this.fxUserService.userInfo['c_cus']
      }
    };
    this.http.post<any>('D/IFxdi405Service/getFrameInfo', param).subscribe(
      response => {
        console.log(this.load, '获取框架结构入口')
        if (response.data && Object.keys(response.data).length) {
          this.listDatas = response.data.data_raw;
          this.phoneCode = response.data.dfa1_list.length ? response.data.dfa1_list[0] : '';
          var logoCode = response.data.dfa4_list.length ? response.data.dfa4_list[0] : ''; // 商城logo
          console.log(this.phoneCode, 'listDatas')
          if (response.data.dfa1_list.length > 0) {
            for (const key in this.phoneCode) {
              //console.log(key,this.phoneCode[key],this.phoneCode[key].hasOwnProperty('dfa004'),this.phoneCode[key].dfa004)
              if (key == 'dfa004') {
                this.iphoneImg = this.phoneCode[key];
              }
              if (key == 'dfa003') {
                this.iphoneIntro = this.phoneCode[key];
              }
              if (key == 'dfa002') {
                this.iphoneCode = this.phoneCode[key];
              }
            }
          }
          // 商城logo
          if (logoCode) {
            this.logoImg = logoCode.dfa004 ? logoCode.dfa004 : ''; // 商城logourl
            sessionStorage.setItem('logoImgUrl', this.logoImg);
            this.logoTxt = logoCode.dfa004 ? logoCode.dfa002 : ''; // 商城logourl
          }
        }
        setTimeout(() => {
          this.load.getMask('', false)
        }, 800);
      }, error => {
        this.layoutFrame = [];
      }
    )
  }

  // 获取用户信息
  async getUserInfo(): Promise<any> {

    // 根据是否登陆获取对应的权限范围
    // (this.fxUserService.userInfo['c_user'] && !this.fxUserService.userInfo['c_cus'])
    if (!this.fxUserService.userInfo['c_user'] && !this.fxUserService.userInfo['c_cus']) { // 登陆前的权限范围
      if(!this.ent) return;
      await this.http.post('A/ILoginService/getDataBeforeLogin', { param: { "language": this.fxUserService.userInfo['c_lang'] ? this.fxUserService.userInfo['c_lang'] : this.browserLang, "ent": this.ent, "dfb003": this.fxUserService.userInfo['c_cus'] } }, {
      }).subscribe((response: any) => {
        if (response.success) {
          if(response.data.length > 0) {
          // 获取默认渠道
          const idx = response.data.findIndex(obj => {
            return obj.show_default === 'Y';
          });
          this.fxUserService.userInfo['c_cus'] = response.data[idx !== -1 ? idx : 0].dfb002;
          this.fxUserService.userInfo['c_cus_n1'] = response.data[idx !== -1 ? idx : 0].dfb002_n1;
          this.fxUserService.userInfo['c_lang'] = response.data[idx !== -1 ? idx : 0].mainlang;
          this.fxUserService.userInfo['scope_list'] = response.data;
          this.fxUserService.setUserInfo(this.fxUserService.userInfo);
          this.translateService.setDefaultLang(response.data[idx !== -1 ? idx : 0].mainlang);
          this.languageService.setUp(response.data[idx !== -1 ? idx : 0].mainlang);
          this.initData(response.data);
          }

        } else {
          this.dwMessage.errorNew(response.message, "", "", "");
        }
        setTimeout(() => {
          this.load.getMask('', false);
        }, 800);
      }, (error: any) => {
        if (this.isInputEnt) {
          this.router.navigate(['./404']);
        }
        this.translateService.instant('fxed020-back-homepage')
        this.dwMessage.error("权限范围获取有误！");
        setTimeout(() => {
          this.load.getMask('', false);
        }, 800);
      });
    } else { // 登陆后的权限范围
      // 获取默认渠道
      // const idx = this.fxUserService.userInfo['scope_list'].findIndex(obj => {
      //   return obj.show_default === 'Y';
      // });
      // this.fxUserService.setUserInfo({
      //   c_cus: this.fxUserService.userInfo['scope_list'][idx !== -1 ? idx : 0].dfb002,
      //   c_cus_n1: this.fxUserService.userInfo['scope_list'][idx !== -1 ? idx : 0].dfb002_n1,
      //   c_lang: this.fxUserService.userInfo['scope_list'][idx !== -1 ? idx : 0].mainlang,
      //   scope_list: this.fxUserService.userInfo['scope_list']
      // });
      // this.orgList = this.fxUserService.userInfo['scope_list'];
      if (this.fxUserService.userInfo['isLoggedin'] === true && !this.fxUserService.userInfo['scope_list']) {
        this.fxUserService.read(this.fxUserService.userInfo['c_user'], this.fxUserService.userInfo['c_ent']).subscribe(
          data => {
            console.log('test----');
            this.initData(this.fxUserService.userInfo['cust_list']);
            if (!data['success']) {
              this.dwModalService.error({
                dwContent: data['description'],
              });
              this.translateService.setDefaultLang(this.fxUserService.userInfo['c_lang']);
              this.languageService.setUp(this.fxUserService.userInfo['c_lang']);
            }
            setTimeout(() => {
              this.load.getMask('', false)
            }, 800);
          }, error => {
            console.log(error);
          }
        );
      } else {
        this.fxUserService.getCommonService();
        this.translateService.setDefaultLang(this.fxUserService.userInfo['c_lang']);
        this.languageService.setUp(this.fxUserService.userInfo['c_lang']);
        this.initData(this.fxUserService.userInfo['cust_list']);
      }
      this.getMenuTreeByUser(true);// 获取菜单
    }
  }

  // 获取查询条件
  getSearchCondition(): any {
    let param = {
      "param": {
        ent: this.ent,
        aan001: this.fxUserService.userInfo['c_user'],
        aaalang: this.fxUserService.userInfo['c_lang'],
      }
    }
    const method = this.fxUserService.userInfo['c_user'] ? 'A/IMobileQrySettingService/getQrySettingInfoByEshop' : 'A/IMobileQrySettingService/getQrySettingInfoByEshopAnonymous';
    this.http.post(method, param, { headers: { 'program-code': 'fxed020' } }).subscribe(response => {
      if (response.success) {
        if (response.data.fuzzy_field_list && response.data.fuzzy_field_list.length > 0) {
          this.serchstrInfo = response.data.fuzzy_field_str != null && response.data.fuzzy_field_str != '' ? response.data.fuzzy_field_str : '请输入商品';
        }
      }
    })
  }

  async switchOrg(org: any): Promise<any> {
    // 检查是否是同组织
    if (this.userInfo.custId === org.daecust) {
      return;
    }
    // 防呆提示
    try {
      const ok = await this.fxModalService.confirm$({ message: this.translateService.instant('fxed020-back-homepage') }).toPromise();
    } catch (e) {
      return;
    }

    // 切换组织
    this.userInfo.custId = org.daecust;
    this.userInfo.custName = org.daecust_n1;
    // 更新 token
    try {
      this.fxUserService.userInfo['c_cus'] = org.daechnl;
      this.fxUserService.userInfo['c_cust'] = org.daecust;
      this.fxUserService.userInfo['c_cust_n1'] = org.daecust_n1;
      // this.fxUserService.userInfo['c_cus_n1'] = org.dfb002_n1;
      // this.fxUserService.userInfo['c_lang'] = org.mainlang || this.fxUserService.userInfo['c_lang'];
      this.fxUserService.setUserInfo(this.fxUserService.userInfo);
      // this.translateService.setDefaultLang(org.mainlang);
      // this.languageService.setUp(org.mainlang);
      // sessionStorage.setItem('isSwitchOrg', 'Y')
      this.initData(this.custList);
      this.router.navigate(['/home']);
    } catch (e) {
      console.error(this.translateService.instant('fxed020-switch-org-fail'), e);
    }
  }

  //切换语言别
  async switchLang(item: any): Promise<any> {
    if (this.userInfo.mainLang === item.value) { return;}
    // 防呆提示
    try {
      const ok = await this.fxModalService.confirm$({ message: this.translateService.instant('fxed020-back-homepage') }).toPromise();
    } catch (e) {
      return;
    }

    // 切换组织
    this.userInfo.mainLang = item.value;
    this.userInfo.mainLangName = item.label;
    // 更新 token
    try {
      const newTokenRes: any = await this.http.post('A/ILoginService/switchOrg', {param: {language: item.value }}).toPromise();
      // sessionStorage.setItem('DwFxed020UserInfo', JSON.stringify({token: newTokenRes.token}));

      this.fxUserService.userInfo['c_lang'] = item.value || this.fxUserService.userInfo['c_lang'];
      this.fxUserService.userInfo['token'] = newTokenRes.token;
      this.fxUserService.setUserInfo(this.fxUserService.userInfo);
      // this.translateService.setDefaultLang(org.mainlang);
      // this.languageService.setUp(org.mainlang);
      // sessionStorage.setItem('isSwitchOrg', 'Y')
      this.initData(this.custList);
      this.router.navigate(['/home']);
    } catch (e) {
      console.error(this.translateService.instant('fxed020-switch-org-fail'), e);
    }
  }

  // 登入pc
  public goSystem() {
    let sysUrl = '';
    this.systemConfig.get('fxUrl').subscribe(url => sysUrl = url + '?ent=' + this.ent  + '?token=' + this.fxUserService.userInfo['token']);
    if (sysUrl) {
      sessionStorage.setItem('DwUserInfo', sessionStorage.getItem('DwFxed020UserInfo'));
      window.open(sysUrl);
    }
  }

  // 登出
  onLoggedout() {
    // 登出方法应该在 authService 中定义
    // 但现在 DwAuthService 和 FxAuthService 之间有奇怪的引用关系暂未厘清
    // 现在先放这儿
    var param = {
      c_ent: this.fxUserService.userInfo['c_ent'],
      language: this.fxUserService.userInfo['c_lang']
    }
    this.onChangeUser(param, 'out');
    // this.fxUserService.clearUserInfo();
    // this.fxUserService.clearUser();
    // sessionStorage.clear();

    // this.authService.logout();


  }


  onChangeUser(param, type) {
    this.http.post('A/ILoginService/touristAuthorize', {param: param}).subscribe((response: any) => {
      if (response.token) {
        this.fxUserService.clearUserInfo();
        console.log('login response:', response);
        let token = {id: 'token', value: response.token};
        this.fxUserService.setUser(token);
        var userinfo = JSON.parse(response.data);
        this.userInfo = {
          userId: userinfo.c_user,
          userName: userinfo.c_user_n1,
          orgId: userinfo.c_org,
          orgName: userinfo.c_org_n1,
          custId: userinfo.c_cust,
          custName: userinfo.c_cus_n1,
          mainLang: userinfo.c_lang || this.translateService.getDefaultLang(),
          mainLangName: this.getLangName(userinfo.c_lang || this.translateService.getDefaultLang())
        };
        this.fxUserService.setUser(userinfo);
        this.authService.setLogined(userinfo);
        this.getUserInfo();
        if (type=='out') {
          this.router.navigate(['/home']);
        }
      } else  {
        this.dwMessage.error('获取游客信息失败，请联系管理员！');
      }
      setTimeout(() => {
        this.load.getMask('', false)
      }, 800);
    },(error:any) => {
      this.dwMessage.error('获取游客信息失败，请联系管理员！');
      setTimeout(() => {
        this.load.getMask('', false)
      }, 800);
    });
  }
  // 修改密码
  onChangePassword(): void {
    const modal = this.dwModalService.create({
      dwTitle: this.translateService.instant('fxed020-modify-password-title'),
      dwStyle: { top: '40px' },
      dwWidth: 400,
      dwMaskClosable: true, // 點擊遮罩是否允許關閉
      dwContent: ChangePasswordComponent,
      dwComponentParams: {
      },
      dwFooter: [
        {
          label: this.translateService.instant('fxed020-取消'),
          shape: 'default',
          onClick: (data: any): void => {
            modal.destroy();
          }
        },
        {
          label: this.translateService.instant('fxed020-确定'),
          type: 'primary',
          onClick: (data: any): void => {
            console.log(data.myform.value);
            var result = data.myform.value;
            if (result.new_password == "" || result.old_password == "" || result.sure_password == "") {
              //界面栏位不可存在空值！
              this.dwMessage.error(this.translateService.instant('fxed020-not-empty-field'));
              return;
            }
            let abj004 = crypto.MD5(result.old_password);
            let newAbj004 = crypto.MD5(result.new_password);
            let confirmAbj004 = crypto.MD5(result.sure_password);
            this.http.post('A/IFxai025Service/modifyPsd', {
              param: {
                abj001: result.userId,// 用户编号
                abj004: abj004 + '',//  原密码
                newAbj004: newAbj004 + '',//   新密码
                confirmAbj004: confirmAbj004 + ''//  确认新密码
              }
            }).subscribe(
              response => {
                console.log(response, 'modifyPsd')
                if (response['success']) {
                  modal.close({});
                  this.onLoggedout();

                } else {
                  this.dwMessage.error(response['message']);
                  return;
                }
                setTimeout(() => {
                  this.load.getMask('', false)
                }, 800);
              }, error => {
              }
            );
          }
        }
      ],
    });
  };

  openPayPage() {
    const modal = this.dwModalService.create({
      dwTitle: "线上支付",
      dwStyle: { top: '40px' },
      dwWidth: 800,
      dwMaskClosable: false, // 點擊遮罩是否允許關閉
      dwWrapClassName: 'fx_md_modal',
      dwContent: Fxed020PayNewComponent,
      dwComponentParams: {},
      dwFooter: [
        {
          label: "取消",
          shape: 'default',
          onClick: (data: any): void => {
            modal.destroy();
            this.load.getMask('',false);
          }
        },
        {
          label: "确定",
          type: 'primary',
          onClick: (data: any): void => {
            console.log(data);
            if(data.is_add){
              if (data.myform.value.gca001 == "" || data.myform.value.gca001 == null || data.myform.value.gca001 == undefined
              || data.myform.value.gcaaobj == "" || data.myform.value.gcaaobj == null || data.myform.value.gcaaobj == undefined) {
                //界面栏位不可存在空值！
                this.dwMessage.errorNew(this.translateService.instant('必输栏位必填！'), "", "", "");
                return;
              }
            // }else{
            //   if (data.selectedList[0].data.gcadocno == "" || data.selectedList[0].data.gcadocno == null || data.selectedList[0].data.gcadocno == undefined
            //   || data.selectedList[0].data.gcaaobj == "" || data.selectedList[0].data.gcaaobj == null || data.selectedList[0].data.gcaaobj == undefined) {
            //     //界面栏位不可存在空值！
            //     this.dwMessage.errorNew(this.translateService.instant('必输栏位必填！'), "", "", "");
            //     return;
            //   }
            }
            var flag = false;
            var param_baf001 = '';
            var param_baf004 = '';
            data.pay_lists.forEach(element => {
              if (element.checked && element.checked == true) {
                flag = true;
                param_baf001 = element.baf001;
                param_baf004 = element.baf004;
              }
            });
            if (!flag) {
              this.dwMessage.errorNew(this.translateService.instant('支付方式必选！'), "", "", "");
              return;
            }
            var self = this;
            //新增 start
            if (data.is_add) {
              var param = {
                gcadtype: '2', //支付方式 1.线下支付 2。线上支付
                gcaent: '',               // 集团参数
                gcastus: 'N',             // 状态码
                gcalock: '1',               // 乐观锁
                gcalegal: '',
                gcalegal_n1: '',
                gcalorg: this.fxUserService.userInfo["c_org"],                // 账款组织
                // gcalorg_n1: this.userinfo.userInfo["c_org"],              // 账款组织名称
                gcadocno: '',                 // 申请单号
                gcaddate: moment(new Date()).format('YYYY/MM/DD'),            // 账款日期
                gcaaobj: data.myform.value.gcaaobj,
                gcaaobj_n1: '',
                gca001:Number (data.myform.value.gca001),
                gca002: '',
                gcabper: '',
                gcabper_n1: '',
                gcanote: '',
                gcacurr: data.myform.value.gcacurr,
                gcacper: this.fxUserService.userInfo["c_user"],
                // gcacper_n1: app.c_user_n1,
                gca003: '1',//支付状态 1.未支付
                gcaerate: 1,
                gcb_f_list: [{
                  gcbseq: 1,
                  gcb001: param_baf001,//支付方式
                  gcbamt: data.myform.value.gca001,//支付金额
                  gcbsorg: this.fxUserService.userInfo["c_org"],//来源组织
                  gcbtype: '1',//类型
                }]
              }
              this.load.getMask('',false);
              this.http.post('G/IFxgd100Service/addData', { 'param': param}).subscribe(response => {//新增方法
                if (response.success) {
                  // 唤起支付start
                  var _param =
                  {
                    "baf001": param_baf001, //支付方式
                    "baf004": param_baf004, //支付方式
                    "orderId": response.data.gcadocno, //支付单号
                    "txnAmt": response.data.gcb_f_list[0].gcbamt,
                  }
                  console.log(_param);
                  self.http.post('G/IGCommonService/getPaymentResult', { 'param': _param}).subscribe(response1 => {
                    if (response1.success) {
                      console.log(response1)
                      if (param_baf004 == 'B2B001-01') { //公对公支付跳出链接
                        window.open(response1.data.payUrl);
                      } else {
                        var qrCode = response1.data.qrCode;
                        var amt = response.data.gcb_f_list[0].gcbamt;
                        const modal = this.dwModalService.create({
                          dwTitle: "请使用支付宝/微信/云闪付扫码支付",
                          dwStyle: { top: '40px' },
                          dwWidth: 600,
                          dwWrapClassName: 'fx_md_modal',
                          dwMaskClosable: true, // 點擊遮罩是否允許關閉
                          dwContent: Fxed020QRcodeComponent,
                          dwComponentParams: {
                            qrCode: qrCode,
                            amt: amt
                          },
                          dwFooter: [
                            {
                              label: "取消",
                              shape: 'default',
                              onClick: (data: any): void => {
                                clearInterval(loop); //清除周期执行触发器
                                modal.destroy();
                                this.load.getMask('',false);
                              }
                            },
                            {
                              label: "确定",
                              type: 'primary',
                              onClick: (data: any): void => {
                                clearInterval(loop); //清除周期执行触发器
                                modal.close({});
                                this.load.getMask('',false);
                              }
                            }
                          ],
                        });
                        var s_time = new Date().getTime(); //当前时间
                        var maxTime = 120000; //支付超时时间
                        var loop = setInterval(function () {
                          var jg_time = (new Date().getTime()) - s_time;
                          if (jg_time > maxTime) { //支付超时
                            clearInterval(loop);
                            this.dwMessage.errorNew(this.translateService.instant('支付超时'), '', '', ''); //获取支付结果超时，请刷新页面查看应支付金额或联系管理员
                            this.load.getMask('',false)
                          } else {
                            var param = { "gca_list": [{ "gcadocno": response.data.gcadocno }] };
                            self.http.post('G/IGCommonService/getOrderResult', { 'param': param}).subscribe(response2 => {
                              if (response2.data[0].gca003 == '2') {
                                self.dwMessage.success(self.translateService.instant('支付成功!')); //获取支付成功

                                clearInterval(loop); //清除周期执行触发器
                                modal.close({});
                                self.load.getMask('',false);
                              }
                            })
                          }
                        }, 5000);
                      }

                    } else {
                      this.dwMessage.errorNew(response1.message, response1.isRemind, response1.programNo, response1.programName);
                      this.load.getMask('',false);
                    }
                  });
                  // 唤起支付end

                } else {
                  this.dwMessage.errorNew(response.message, response.isRemind, response.programNo, response.programName);
                  this.load.getMask('',false);
                }
              });
            // } else {
            //   // 唤起支付start
            //   var _param =
            //   {
            //     "baf001": param_baf001, //支付方式
            //     "baf004": param_baf004, //支付方式
            //     "orderId": data.selectedList[0].data.gcadocno, //支付单号
            //     "txnAmt": data.selectedList[0].data.gca001,
            //   }
            //   console.log(_param);
            //   this.http.post('G/IGCommonService/getOrderResult', { 'param': _param}).subscribe(response1 => {
            //     if (response1.success) {
            //       console.log(response1)
            //       if (param_baf004 == 'B2B001-01') { //公对公支付跳出链接
            //         window.open(response1.data.payUrl);
            //       } else {
            //         var qrCode = response1.data.qrCode;
            //         var amt =data.selectedList[0].data.gca001;
            //         const modal = this.dwModalService.create({
            //           dwTitle: "请使用支付宝/微信/云闪付扫码支付",
            //           dwStyle: { top: '40px' },
            //           dwWidth: 600,
            //           dwWrapClassName: 'fx_md_modal',
            //           dwMaskClosable: true, // 點擊遮罩是否允許關閉
            //           dwContent: Fxed020QRcodeComponent,
            //           dwComponentParams: {
            //             qrCode: qrCode,
            //             amt: amt
            //           },
            //           dwFooter: [
            //             {
            //               label: "取消",
            //               shape: 'default',
            //               onClick: (data: any): void => {
            //                 clearInterval(loop); //清除周期执行触发器
            //                 modal.destroy();
            //               }
            //             },
            //             {
            //               label: "确定",
            //               type: 'primary',
            //               onClick: (data: any): void => {
            //                 clearInterval(loop); //清除周期执行触发器
            //                 modal.close({});
            //               }
            //             }
            //           ],
            //         });
            //         var s_time = new Date().getTime(); //当前时间
            //         var maxTime = 120000; //支付超时时间
            //         var loop = setInterval(function () {
            //           var jg_time = (new Date().getTime()) - s_time;
            //           if (jg_time > maxTime) { //支付超时
            //             clearInterval(loop);
            //             this.dwMessage.errorNew(this.translateService.instant('支付超时'), '', '', ''); //获取支付结果超时，请刷新页面查看应支付金额或联系管理员
            //             // this.load.getMask('',false)
            //           } else {
            //             var param = { "gca_list": [{ "gcadocno": data.selectedList[0].data.gcadocno }] };
            //             self.http.post('G/IGCommonService/getOrderResult', { 'param': param}).subscribe(response2 => {
            //               console.log('response2:', response2)
            //               if (response2.data[0].gca003 == '2') {
            //                 self.dwMessage.success(self.translateService.instant('支付成功!')); //获取支付成功
            //                 clearInterval(loop); //清除周期执行触发器
            //                 modal.close({});
            //               }
            //             })
            //           }
            //         }, 5000);
            //       }

            //     } else {
            //       this.dwMessage.errorNew(data.selectedList[0].message, data.selectedList[0].isRemind, data.selectedList[0].programNo, data.selectedList[0].programName);
            //     }
            //   });
            //   // 唤起支付end
            }
            modal.close({});
            this.load.getMask('',false);
          }
        }
      ],
    });
    setTimeout(() => {
      this.load.getMask('', false)
    }, 0);
  }

  // // 我的购物车
  // linkCar() {
  //   this.router.navigate(['./car'], { relativeTo: this.route });
  // }

  // 跳转下载中心、学习中心、我的中心、我的购物车、我的订单
  changeRoute(routes) {
    if (!this.userInfo.userId) {
      // this.dwMessage.errorNew(this.translateService.instant('fxed020-please-login'), "", "", "");
      this.fxLoingingService.openLoginModal();
    } else {
      this.router.navigate([routes], { relativeTo: this.route });
    }
  }

  hiddenPic(idx) {
    // document.getElementById("Layer1").innerHTML = "";
    document.getElementById(idx).style.display = "none";
  }

  showPic(idx) {
    // document.getElementById("Layer1").style.left = "0px";
    // document.getElementById("Layer1").style.top = "0px";
    // document.getElementById("Layer1").innerHTML = "<img src=\"" + sUrl + "\">";
    document.getElementById(idx).style.display = "block";
  }


  // 登陆
  login() {
    this.fxLoingingService.openLoginModal();
  }


  //页签入口
  isTab(e) {
    console.log(e);
    this.isShow = e;
    // if(e=='案例中心'){
    //   this.router.navigate(['./querySolutionCenter']);
    // }else{
    //   this.router.navigate(['./info']);
    // }
  }

  //扫码关注
  isClickIphone() {
    console.log('111')
    this.isShowIphone = !this.isShowIphone;
  }

}
